export default __webpack_public_path__ + "static/media/19.3c7f8b84.jpeg";